var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticStyle: { display: "none" },
      attrs: { id: "child-comment-" + _vm.newsfeed_id },
    },
    [
      _vm._l(_vm.items, function (comment, index) {
        return _c(
          "div",
          { key: comment.id },
          [
            _c("child-comment", {
              attrs: { data: comment, administrator: _vm.administrator },
              on: {
                deleted: function ($event) {
                  return _vm.remove(index)
                },
              },
            }),
          ],
          1
        )
      }),
      _vm._v(" "),
      _c("new-comment", {
        attrs: {
          type: this.type,
          slug: _vm.slug,
          members: _vm.members,
          parent: false,
        },
        on: { created: _vm.add },
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }